// update chat unread messages count
export const UPDATE_CHAT_UNREAD_MESSAGES_COUNT_SUCCESS =
  'UpdateChatUnreadMessagesCountSuccess';
export const UPDATE_CHAT_UNREAD_MESSAGES_COUNT_ERROR =
  'UpdateChatUnreadMessagesCountError';
